import React, { useEffect, useState, useRef, memo } from 'react'
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsBoost from "highcharts/modules/boost";
import { getOptions, addFunctionsToChartOptions, addThirdKPI } from "./chartlogic"
import { useDispatch, useSelector } from 'react-redux';
import { updateAppState } from '../../actions/appstate';
import Alert from '@mui/material/Alert';
import { transformData, getMergedData, getForecastChartEffCapacity } from './functions';
import { Box, AlertTitle } from '@mui/material';
import {
  getTileById, getCompsetMedian,
  getResourceIdByPropId, getSeriesById,
  deepCopy, getFromState, getTransformedSegments, filterTopSegments,
  aggregateObject, dateFormat, in_array, getSDLYorSDTLYDate, getPermissions,
} from '../../app/util';
import '../../simple-grid.css';
import './chart-view.css';
import moment from 'moment';
import DataService from "../../services/data.service";
import { UPDATE_STATE } from '../../actions/types';
import { APP_CACHE, TILES } from "../../app/config";
import GraphSkeletonLoader from "../Loader/GraphSkeletonLoader";
// HighchartsBoost(Highcharts); 
function ChartCommon({ compDisplayData }) {
  // debugger;  
  const dispatch = useDispatch();
  const state = useSelector(appState => appState);
  const { property_details } = useSelector(state => state.auth.profile);
  const { app_state, ui_state } = useSelector(state => state.app.current_state);
  const { workspace_controls } = app_state;
  const { sdlyOn, segmented_view, pickUpType, segmentType, dayDate } = workspace_controls;
  const { permissions, index } = getPermissions(property_details, app_state.property_id);
  const [displayData, setDisplayData] = useState([]);
  const [compLoad, setCompLoad] = useState(false);
  const [options, setOptions] = useState({});
  const [chartLoaded, setChartLoaded] = useState(false);
  const resource_id = getResourceIdByPropId(app_state.property_id, property_details);
  let segments = null;

  // Create a ref to hold the worker instance
  const workerRef = useRef(null);

  // Initialize worker once on component mount
  useEffect(() => {
    // Create the worker only if it doesn't exist yet
    if (!workerRef.current) {
      workerRef.current = new Worker('/workers/highcharts-worker.js');

      // Set up the message handler
      workerRef.current.onmessage = function (e) {
        const { type, chartOptions, error } = e.data;

        if (type === 'error') {
          console.error('Worker error:', error);
          setChartLoaded(true); // Stop the loading state even if there's an error
          return;
        }

        if (type === 'initialized' && chartOptions) {
          console.timeEnd("worker time");

          const useVarCapacity = !!(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled);
          let param = {
            ...app_state.primary_stay_range,
            ...app_state.workspace_controls,
            active_api: app_state.active_api,
            ...ui_state,
            resource_id,
            segmented_view,
            pickUpType,
            segments,
            total_capacity,
            workspace_controls: app_state.workspace_controls,
            property_id: app_state.property_id,
            property_details: property_details,
            lv1_segGrouping: filterTopSegments(lv1_segGrouping),
            hasUserForecastData: false,
            useVarCapacity,
          };
          console.time("addFunctionsToChartOptions time");
          const processedOptions = addFunctionsToChartOptions(chartOptions, displayData, ui_state, app_state, param);

          setChartLoaded(true);
          console.timeEnd("addFunctionsToChartOptions time");
          setOptions({ options, ...processedOptions });
        }
      };
    }

    // Cleanup worker when component unmounts
    return () => {
      if (workerRef.current) {
        workerRef.current.terminate();
        workerRef.current = null;
      }
    };
  }, []);

  const hasInfoBoxTable = () => {
    let infoText = false;
    if (compDisplayData.length === 0 || (compDisplayData && compDisplayData.data && compDisplayData.data.length <= 0) || (compDisplayData && compDisplayData.length > 0 && compDisplayData[0].data && compDisplayData[0].data.length <= 0)) {
      infoText = 'Data for ' + ui_state.active_tiles[0] + ' is not available, Please contact success@lodgiq.com for further details.';
    }

    if (ui_state.active_tiles[0] === 'budget' && permissions.budget === 0) {
      infoText = 'Budget is not uploaded for this property! Please upload the budget through the uploads menu in report section. If you need any further help, Please contact success@lodgiq.com for further details.';
    }



    return infoText;
  }
  let inventory = getFromState('system_settings>inventory_settings', state);
  if (!inventory) console.error("inventory_settings is not available for this property");
  const { total_capacity } = inventory && inventory.current ? inventory.current : {};
  // debugger
  let marketSegments = getFromState('system_settings>market_segment_category_mapping', state);
  let lv1_segGrouping = getFromState('system_settings>lvl1_mseg_grouping', state);
  if (segmented_view) {
    // debugger
    let marketSegments = getFromState('system_settings>market_segment_category_mapping', state);
    let segment_ignore_codes = getFromState('system_settings>market_code_ignorelist', state);
    segments = getTransformedSegments(marketSegments, segment_ignore_codes);
    // segments = getTransformedSegments(marketSegments);  
  }

  let compRef = useRef({
    compLoad: false
  });

  useEffect(() => {
    // debugger;
    let isSubscribed = true;
    let apc = APP_CACHE;
    let apcChartData = null; //apc.chartData;
    if (apcChartData && !sdlyOn && app_state.changing_view && app_state.changing_view === 'chart') {
      // debugger
      setOptions({ options, ...apcChartData });
      compRef.current.compLoad = true;
      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            changing_view: ""
          }
        },
      });
    } else {
      if (isSubscribed && compRef.current.compLoad && displayData && displayData.length) {
        const useVarCapacity = !!(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled);
        let param = {
          ...app_state.primary_stay_range,
          ...app_state.workspace_controls,
          active_api: app_state.active_api,
          ...ui_state,
          resource_id,
          segmented_view,
          pickUpType,
          segments,
          total_capacity,
          workspace_controls: app_state.workspace_controls,
          property_id: app_state.property_id,
          property_details: property_details,
          lv1_segGrouping: filterTopSegments(lv1_segGrouping),
          hasUserForecastData: false,
          useVarCapacity,
        };

        //Set true if user forecast is not blank
        if (ui_state.active_tiles.includes('forecast')) {
          let userForecast = getSeriesById('ManualForecast').data;
          if (userForecast && userForecast.data && userForecast.data.length) {
            param.hasUserForecastData = true;
          }
        }

        let thirdKPI = null;
        let thirdKPITiles = ['pace'];
        if (ui_state.active_tiles[0] === 'pace') {
          if (ui_state.left_measure !== 'SellRate' && ui_state.right_measure !== 'SellRate') {
            thirdKPI = 'SellRate';
            param.third_measure = thirdKPI;
          }
        }

        if (ui_state.active_tiles[0] === 'bi_sensitivity_analysis') {
          setChartLoaded(false);
          console.time("worker time");

          // Use the worker reference instead of creating a new instance
          if (workerRef.current) {
            workerRef.current.postMessage({
              type: 'init',
              options: { displayData, ui_state, app_state, param }
            });
          }
        } else {
          let chartOptions = getOptions(displayData, ui_state, app_state, param);
          chartOptions.boost = {
            useGPUTranslations: true,
            seriesThreshold: 3,
            enabled: true,
          };
          if (thirdKPI !== null &&
            (param.left_measure !== null || param.right_measure !== null)
          ) {
            let thirdParam = deepCopy(param);
            thirdParam.right_measure = thirdKPI;
            let thirdChartOptions = getOptions(displayData, ui_state, app_state, thirdParam);
            chartOptions = addThirdKPI(chartOptions, thirdChartOptions, thirdKPI, thirdKPITiles);
          }
          apc.chartData = deepCopy(chartOptions);
          setOptions({ options, ...chartOptions });


        }

      }

      return () => {
        isSubscribed = false;
        dispatch({
          type: "UPDATE_STATE",
          payload: {
            app_state: {
              changing_view: ""
            }
          },
        });
      }
    }
  }, [compLoad]);


  useEffect(() => {
    let isSubscribed = true;

    if (!ui_state.showspinner && !compRef.current.compLoad) {
      // debugger
      if (compDisplayData && compDisplayData.length === 1) {
        let transformedData = [];

        if (['market'].includes(ui_state.active_tiles[0])) {
          transformedData = getMergedData(compDisplayData, { ui_state: ui_state, app_state: app_state, segments });
          transformedData.map((item) => {
            if(item.order && item.order.length > 0) {
              item.order = item.order.sort((a, b) => {
                const segOrder = (seg) => seg.toLowerCase() === 'total' ? 3 : seg.toLowerCase() === 'other' ? 2 : seg.toLowerCase() === 'unmapped' ? 1 : 0;
                const oa = segOrder(a.name);
                const ob = segOrder(b.name);
                if (oa !== ob) return oa - ob;
                return a.name.localeCompare(b.name);
              });
            }
            return item;
          });

        } else if (compDisplayData[0].data) {
          let params = {
            dataSet: compDisplayData[0].data, data_id: compDisplayData[0].data_id,
            segmentType, topSegments: filterTopSegments(lv1_segGrouping),
            range: app_state.primary_stay_range,
            segments,
            useVarCapacity: !!(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled),
          }

          transformedData = transformData(params);
        }
        compRef.current.compLoad = (transformedData && transformedData.length > 0);

        setDisplayData(transformedData);
        setCompLoad(true);
      }
      if (compDisplayData && (compDisplayData.constructor.name === 'Array' && compDisplayData.length > 1)) {
        let mergedData = [];
        let transformedData = [];
        let topSegments = filterTopSegments(lv1_segGrouping);

        try {
          mergedData = getMergedData(compDisplayData, { ui_state: ui_state, app_state: app_state, segments, topSegments, useVarCapacity: !!(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled) });
        } catch (e) {
          console.warn("Code Block Failed!!", e);
        }

        // debugger;  
        if (ui_state.active_tiles.includes('forecast')) {
          let params = {};
          if (segmented_view) {
            params = {
              dataSet: mergedData, data_id: 'OSRSegment',
              range: ui_state.primary_stay_range, segments,
              topSegments: filterTopSegments(lv1_segGrouping), segmentType
            };


            transformedData = transformData(params);
            compRef.current.compLoad = true;
            setDisplayData(transformedData);
            setCompLoad(true);

          } else {
            let userForecast = getSeriesById('ManualForecast').data;
            if (userForecast && userForecast.data && userForecast.data.length) {
              let totalKey = 'HotelTotal';
              const useVarCapacity = !!(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled);
              mergedData.forEach((item) => {
                let manualForecast = userForecast.data.find(data => new moment(item.index.date).isSame(data.index.date, 'day'))
                if (manualForecast) {
                  let dateData = deepCopy(manualForecast.total_forecast);
                  // The uploaded feed's Occ%/RevPAR are fixed-capacity numbers, so charting them as-is
                  // leaves the User Forecast series flat while the system forecast series moves with the
                  // Variable Capacity toggle. Re-derive both from the uploaded Rooms/Revenue over the same
                  // per-date capacity the forecast series uses. Chart Occ is a fraction, not a percent.
                  const effCap = getForecastChartEffCapacity(item.index.date, useVarCapacity);
                  if (effCap) {
                    dateData.Occ = (Number(dateData.Rooms) || 0) / effCap;
                    dateData.RevPAR = (Number(dateData.Revenue) || 0) / effCap;
                  } else {
                    dateData.Occ = dateData['Occ%'] / 100;
                  }
                  delete dateData['Occ%'];
                  item[totalKey].userforecastdata = dateData;
                }
              });
            }
            // transformedData = transformData(params);
            compRef.current.compLoad = true;
            setDisplayData(mergedData);
            setCompLoad(true);
          }


        } else {
          compRef.current.compLoad = true;
          setDisplayData(mergedData);
          setCompLoad(true);
        }

      }
    }

    return () => (isSubscribed = false)
  }, [
    ui_state.showspinner,
    // ui_state,
    app_state.workspace_controls,
    // app_state.data_load
  ]);

  useEffect(() => {
    // Ensure Highcharts has at least one chart instance
    if (Highcharts.charts.length > 0) {
      let index = Highcharts.charts.length - 1; // Get the latest chart index

      if (Highcharts.charts[index]) {
        setTimeout(() => {
          if (Highcharts.charts[index]) {
            Highcharts.charts[index].reflow(); // Safely trigger reflow
          }
        }, 300);
      }
    }
  }, [ui_state.expanded_view]);

  const renderChart = () => {
    if (ui_state.active_tiles[0] === 'bi_sensitivity_analysis') {

      if (chartLoaded) {
        return (<HighchartsReact highcharts= { Highcharts } options = { options } />)
      } else {
        return (<GraphSkeletonLoader />)
      }
    }
    return (
      <HighchartsReact highcharts= { Highcharts } options = { options } />
    )
}
return (
  <>
  { hasInfoBoxTable() && <Box sx= {{ p: 1 }}>
    <Alert severity="info" >
      <AlertTitle>Info </AlertTitle>
{ hasInfoBoxTable() } </Alert>
  </Box>}

{ compRef.current.compLoad && renderChart() }
{ !compRef.current.compLoad && <GraphSkeletonLoader /> }
{/* {!compRef.current.compLoad && <div style={{ margin: "0 10px" }}><Alert sx={{ hight: 30 }} severity="warning">{(compRef.current.infoTxt) ? compRef.current.infoTxt : "No Data Found!"}</Alert></div>} */ }
</>
  );
}

export default memo(ChartCommon);
